import { Component, Input, OnInit } from '@angular/core';
import { SasisopaService } from '../../../../../services/sasisopa.service';
import { NbDialogRef } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';

type InvestigationActivitiesProgram = {
  station_id: string;
  instalation: string;
  id_event: string;
  type_event: string;
  name_leader: string;
  members: Array<{name: string, speciality: string;}>;
  date_init: string;
  date_end: string;
  activities: Array<{ place: string; date: string; activities: string; resources: string }>;
  responsible_name: string;
  responsible_phone: string;
  responsible_email: string;
  methodology: string;
}
@Component({
  selector: 'ngx-investigation-activities-program-form',
  templateUrl: './investigation-activities-program-form.component.html',
  styleUrls: ['./investigation-activities-program-form.component.scss']
})
export class InvestigationActivitiesProgramFormComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: InvestigationActivitiesProgram & { id: string };
  loading = false;
  data: InvestigationActivitiesProgram = {
    station_id: '',
    instalation: '',
    id_event: '',
    type_event: '',
    name_leader: '',
    members: [{name: '', speciality: ''}],
    date_init: '',
    date_end: '',
    activities: [{ place: '', date: '', activities: '', resources: '' }],
    responsible_name: '',
    responsible_phone: '',
    responsible_email: '',
    methodology: '',
  };

  constructor(
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<InvestigationActivitiesProgramFormComponent>,
  ) { }

  async ngOnInit() {
    this.loading = true;
    await this.checkIfCreateOrEdit();
    this.loading = false;
  }

  async store() {
    this.data.station_id = this.stationId;
    this.loading = true;
    const [error] = await this.sasisopaService.createInvestigationActivitiesProgram(this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Registro creado con éxito', 'success');
    this.ref.close(true);
  }

  async edit() {
    this.loading = true;
    this.data.station_id = this.stationId;
    const [error] = await this.sasisopaService.editInvestigationActivitiesProgram(this.infoEdit.id, this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Registro editado con éxito', 'success');
    this.ref.close(true);
  }

  handleSubmit() {
    if (this.action === 'edit') {
      this.edit();
    } else {
      this.store();
    }
  }

  alert(title: string = '', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  addMember () {
    this.data.members.push({
      name: '',
      speciality: '',
    })
  }

  removeMember (index: number) {
    this.data.members.splice(index, 1);
  }

  addActivity () {
    this.data.activities.push({ place: '', date: '', activities: '', resources: '' })
  }

  removeActivity (index: number) {
    this.data.activities.splice(index, 1);
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') this.data = this.infoEdit
  }
}
